export default __webpack_public_path__ + "static/B0224-973de930cdb2147749dd7c5ae2d30e0b.png";